export default "__VITE_ASSET__CY4B$4RP__"